<div class="modal-body content width-500">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getRessource('Header', { action: isNew ? 'erstellen' : 'ändern'})}}
    </span>
    <div class="content">
			<exg-input [(ngModel)]="dataModelClone.ctName"
			           [caption]="'Konfigurationsname'">
			</exg-input>
			<exg-textarea [(ngModel)]="dataModelClone.ctDescription"
			           [caption]="'Beschreibung'">
			</exg-textarea>
			<app-exg-select-enumeration #VCrcptTyp
			                            [(value)]="dataModelClone.ct_aue_enmIdent_Versicherungsart"
			                            [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_Versicherungsart')"
			                            enumerationName="Versicherungsart">
			</app-exg-select-enumeration>
			<app-exg-select-enumeration [(value)]="dataModelClone.ct_enmIdent_DokTyp"
			                            [caption]="getRessource('ct_enmIdent_DokTyp')"
			                            [required]="true"
			                            [enumerationList]="dokTypList">
			</app-exg-select-enumeration>
	    <exg-switch [(ngModel)]="dataModelClone.ctIsDraft"
	                caption="Entwurf">
	    </exg-switch>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="delete()" class="md-btn"
			        *ngIf="dataModelClone?.ctID">
				{{getGlobal('Delete')}}
			</button>
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="save()"
			        [class.disabled]="isDisabled"
			        class="md-btn">
				{{isNew ? getGlobal('Create') : getGlobal('Save')}}
			</button>
		</div>
	</div>
</div>
